module.exports = __webpack_public_path__ + "static/Old-Display-15a2aef6777d9942092ecb65a52f9dd5.png";